import React, { useEffect, useState, useRef, useContext } from "react";
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container'
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import '@fontsource/roboto/300.css';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';
import { Cookies } from 'react-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { makeStyles } from '@mui/styles';
import LogoNafil from '../../assets/img/NAFIL_logo.svg';
import LogoN from '../../assets/img/NAFIL_logoCurto.svg';
import ImpressaoIcon from '../../assets/img/impressora.svg';
import CloseIcon from '../../assets/img/close.svg';
import { BrowserView, MobileView } from 'react-device-detect';
import { MyContext } from '../../context/MyContext';
import { formatarTelefone, formatarDataHora, numberWithCommas, identificacaoUsuarioLogado } from '../../utils';
import QRCodeStyling from "qr-code-styling";
import { saveAs } from "file-saver";
import { ReactToPrint, useReactToPrint } from 'react-to-print';
import Avatar from '@mui/material/Avatar';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';

export default function (props) {
  let navigate = useHistory();
  // const [open, setOpen] = useState(false);
  const qrCodeRef = useRef(null);
  const [fazerDownload, setFazerDownload] = useState(false);
  const [urlQRCode, setUrlQRCode] = useState("");
  const [linhaDigitavel, setLinhaDigitavel] = useState("");
  const [arquivoFisico, setArquivoFisico] = useState("");
  const [fileExt, setFileExt] = useState("png");
  const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
  const [meusPedidos, setMeusPedidos] = useState([]);
  const [_dadosPedido, set_dadosPedido] = useState([]);
  const [seconds, setSeconds] = useState(0);
  const [intervalID, setIntervalID] = useState(0);
  const { showModalMeuPedido, setShowModalMeuPedido } = useContext(MyContext);
  const componentRef = useRef();

  const dataToPrintRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => dataToPrintRef.current
  });

  function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  function formatarLinhaDigitavel(_linhaDigitavel) {
    let _rtLinhaDigitavel = _linhaDigitavel.replace(/\s/g, '');
    let parte1 = _rtLinhaDigitavel.substring(0, 5);
    let parte2 = _rtLinhaDigitavel.substring(5, 10);

    let parte3 = _rtLinhaDigitavel.substring(10, 15);
    let parte4 = _rtLinhaDigitavel.substring(15, 21);

    let parte5 = _rtLinhaDigitavel.substring(21, 26);
    let parte6 = _rtLinhaDigitavel.substring(26, 32);

    let parte7 = _rtLinhaDigitavel.substring(32, 33);
    let parte8 = _rtLinhaDigitavel.substring(33, 47);

    let _retornoLinhaDigitavel = `${parte1}.${parte2} ${parte3}.${parte4} ${parte5}.${parte6} ${parte7} ${parte8}`;
    return _retornoLinhaDigitavel;
  }

  const handleCloseModal = () => {
    setShowModalMeuPedido(false);
  }

  const iniciarDownload = (_idPedido,_idPedidoLoja,_arquivoFisicoLocal) => {
    saveFile(_arquivoFisicoLocal, _idPedido + "_" + _idPedidoLoja + ".pdf")
  }

  const erroEmail = () => toast.error("Por Favor, Use um E-Mail Válido!",
    { position: toast.POSITION.TOP_CENTER, theme: "colored" });

  const erroSenha = () => toast.error("Por Favor, Digite a Sua Senha!",
    { position: toast.POSITION.TOP_CENTER, theme: "colored" });

  const erroMensagem = (mensagem) => toast.error(mensagem,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const sucessoMensagem = (mensagem) => toast.success(mensagem,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const erroNaoCadastro = () => toast.warning("Usuário Não cadastrado, ou dados de acesso Incorretos",
    { position: toast.POSITION.TOP_CENTER, theme: "colored" });

  const loginSucesso = (nome) => toast.success("Bem Vindo, " + nome,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const pixCopiadoSucesso = (nome) => toast.success("PIX Copiado com Sucesso E",
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 1500 });

  const linhaCopiadaSucesso = (nome) => toast.success("Copiado com Sucesso",
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 1500 });

  const gridStyles = makeStyles((theme) => ({
    container: {
      border: '4px solid green',
      display: 'inline-flex',
    },
    item: { borderRadius: '30px' },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

  const cabecalhoStyles = makeStyles((theme) => ({
    typography: {
      body2: {
        fontSize: [10, "!important"]
      }
    },
  }));

  const cabecalhoStylesMobile = makeStyles((theme) => ({
    typography: {
      body2: {
        fontSize: [4, "!important"]
      }
    },
  }));

  const itensStyles = makeStyles((theme) => ({
    typography: {
      body2: {
        fontSize: [10, "!important"]
      }
    },
  }));

  const itensStylesRodapeMobile = makeStyles((theme) => ({
    typography: {
      body2: {
        fontSize: [6, "!important"]
      }
    },
  }));

  let _dadosPedidoRecebido = props;
  let pesoTotal = 0;
  let quantidadeTotalItens = 0;

  const saveFile = (caminho, nome) => {
    if (fazerDownload) {
      if (caminho !== undefined) {
        saveAs(caminho, nome);
      }
      setFazerDownload(false);
    }
  };

  useEffect(() => {
    if (typeof props?.props !== 'undefined') {
      _dadosPedidoRecebido = props?.props;            
    } else {
      _dadosPedidoRecebido = props;      
    }

    if (typeof _dadosPedidoRecebido?.props !== 'undefined') {
      _dadosPedidoRecebido = _dadosPedidoRecebido?.props;      
      console.log("TESTA ");
    }

    console.log("TESTO ", props);
    
    let _idCliente = 2413;
    let _idClienteLoja = 1;

    //api.get(`Pedidos/AbrirPedido/${_dadosPedidoRecebido?.preVendas.cliente_id}/${_dadosPedidoRecebido?.preVendas.cliente_loja}/${_dadosPedidoRecebido?.preVendas.ids_prevendas}/${_dadosPedidoRecebido?.preVendas.ids_prevendas_loja}/${_dadosPedidoRecebido?.preVendas.total_geral}`)
    api.get(`Pedidos/AbrirPedido/${_idCliente}/${_idClienteLoja}/${_dadosPedidoRecebido?.ids_prevendas}/${_dadosPedidoRecebido?.ids_prevendas_loja}/${_dadosPedidoRecebido?.total_geral}`)
      .then((response) => {
        set_dadosPedido(response.data);
        setUrlQRCode(response.data.pixCopiaCola);
        setLinhaDigitavel(response.data.linhaDigitavel);
        setArquivoFisico(response.data.arquivoFisico);        
      })
      .catch((error) => {
        if (error == "Error: Network Error") {
          erroMensagem("Ops! Deu Algo Errado Com Nosso Servidor")
          return null;
        }
        // console.log(error.message)
      });
  }, []);

  useEffect(() => {

    console.log("EFFETCT MP ", urlQRCode);

    if (urlQRCode != null && urlQRCode.length > 0) {
      const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        data: urlQRCode,
        image:
          LogoN,
        dotsOptions: {
          color: "#000000",
          type: "rounded"
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 5
        }
      });

      qrCode.append(qrCodeRef.current);

      setIntervalID( setInterval(verificarPagamentosPIX, 6000, 'Parameter 1', 'Parameter 2') );
      // const intervalID = setInterval(verificarPagamentosPIX, 6000, 'Parameter 1', 'Parameter 2');
    }
  }, [urlQRCode]);

  useEffect(() => {
    if (fazerDownload){  
      iniciarDownload(_dadosPedido.preVendas.ids_prevendas.toString(), _dadosPedido.preVendas.ids_prevendas_loja.toString(), _dadosPedido.arquivoFisico )
    }
  },[fazerDownload]);

  async function verificarPagamentosPIX(a, b) {
    if (_dadosPedido?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).length > 0) { // 17
      _dadosPedido.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).map((xpag) => { // 17
        api.get(`Pedidos/PIXVerificarPagamentoEfetuado/${xpag.venda_id}/${xpag.venda_loja}/${xpag.especie_id}/${xpag.especie_loja}/${xpag.valor}`).then(res => {
          if (res.status == 200 && res?.data != null && res?.data?.message == null) {
            // SUCESSO NO RECEBIMENTO DO PIX
            xpag.pix_Recebido = res.data;
            sucessoMensagem("PIX Recebido com Sucesso!");
            setUrlQRCode('');
            setShowModalMeuPedido(false);
            clearInterval(intervalID); // Parar Verificação            
          
            return;
          }
        }).catch(err => {
          return false;
        });
      })
    }
  }

  const functionCopyToClipboard = async (e) => {
    navigator.clipboard.writeText(_dadosPedido?.pixCopiaCola);
    pixCopiadoSucesso("PIX Copiado com Sucesso K");
  }

  const functionCopyToClipboardLinhaDigitavel = async (e) => {
    navigator.clipboard.writeText(linhaDigitavel);
    linhaCopiadaSucesso("Copiado com Sucesso");
  }  

  return (
    _dadosPedido.length == 0 ? <></> :

      <div>
        <BrowserView>
          <Grid container justifyContent={"center"} spacing={2}>
            <Grid item xs={6} md={6}>
              <Box display="flex"
                justifyContent="right"
                variant={'rounded'}
                alignItems="center"><Button bgcolor={'color'} onClick={() => setShowModalMeuPedido(false)} startIcon={<Avatar src={CloseIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
            </Grid>
            <Grid item xs={6} md={6}>
              <Box display="flex"
                justifyContent="left"
                variant={'rounded'}
                alignItems="center"><Button bgcolor={'color'} onClick={handlePrint} startIcon={<Avatar src={ImpressaoIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
            </Grid>
          </Grid>

          <div className="div to print" ref={dataToPrintRef}>
            <Container maxWidth="lg" marginBottom={'100px'}>
              <Grid container justifyContent={"center"} spacing={2}>

                <Grid item xs={12} md={12} classeName={gridStyles}>
                  <Box sx={{ width: "100%", marginTop: '10px', borderRadius: 2, border: 1, borderColor: 'grey.300', bgcolor: "#F1F8E9" }}>

                    <Grid container justifyContent={"center"} spacing={2}>
                      <Grid item xs={4} md={4} justifyContent={"left"} display={"flex"}>
                        <Box sx={{ marginTop: '5px', marginBottom: '5px', marginLeft: '10px' }}>
                          <Link to="/"><img src={LogoNafil} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '180px', height: 'auto' }} /></Link>
                        </Box>
                      </Grid>

                      <Grid item xs={4} md={4} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '30px' }} variant="h7" component="div" gutterBottom>
                          Pedido:
                        </Typography>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '22px' }} variant="h6" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.ids_prevendas + "-" + _dadosPedido?.preVendas?.ids_prevendas_loja}
                        </Typography>
                      </Grid>

                      <Grid item xs={4} md={4} justifyContent={"right"} display={"flex"}>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", marginRight: '10px', marginTop: '30px' }} variant="h7" component="div" gutterBottom>
                          Data:
                        </Typography>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginRight: '10px', marginTop: '30px' }} variant="h7" component="div" gutterBottom>
                          {formatarDataHora(_dadosPedido?.preVendas?.data, 6)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderColor: 'grey.300', display: "flex" }}  >

                    <Grid container justifyContent={"center"} spacing={0.7}>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="h7" component="div" gutterBottom>
                          Destinatário:
                        </Typography>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.cliente_razao_social}
                        </Typography>
                      </Grid>

                      <Grid item xs={7} md={7} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Endereço:
                        </Typography>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.endereco + ", " + _dadosPedido?.preVendas?.numero + (_dadosPedido?.preVendas?.complemento.lenght > 0 ? " - " + _dadosPedido?.preVendas?.complemento : "")}
                        </Typography>
                      </Grid>

                      <Grid item xs={3} md={3} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Bairro:
                        </Typography>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.bairro}
                        </Typography>
                      </Grid>

                      <Grid item xs={2} md={2} justifyContent={"right"} display={"flex"}>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", marginRight: '6px' }} variant="h7" component="div" gutterBottom>
                          CEP:
                        </Typography>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginRight: '10px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.cep.substring(0, 5) + "-" + _dadosPedido?.preVendas?.cep.slice(-3)}
                        </Typography>
                      </Grid>

                      <Grid item xs={5.5} md={5.5} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Cidade - UF:
                        </Typography>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.cidadeDestino + " - " + _dadosPedido?.ufDestino}
                        </Typography>
                      </Grid>

                      <Grid item xs={3.5} md={3.5} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Telefone:
                        </Typography>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px' }} variant="h7" component="div" gutterBottom>
                          {formatarTelefone(_dadosPedido?.preVendas?.cliente_telefone)}
                        </Typography>
                      </Grid>

                      <Grid item xs={3} md={3} justifyContent={"right"} display={"flex"}>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", marginRight: '6px' }} variant="h7" component="div" gutterBottom>
                          E-Mail:
                        </Typography>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginRight: '10px' }} variant="h7" component="div" gutterBottom>
                          {(typeof _dadosPedido !== "undefined" && _dadosPedido?.preVendas?.cliente_email != null ? _dadosPedido?.preVendas?.cliente_email.toLowerCase() : "")}
                        </Typography>
                      </Grid>

                      {(_dadosPedido?.preVendas?.referencia.length > 0
                        ?
                        <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                          <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                            Referência:
                          </Typography>
                          <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px' }} variant="h7" component="div" gutterBottom>
                            {_dadosPedido?.preVendas?.referencia}
                          </Typography>
                        </Grid>
                        :
                        <></>
                      )}

                    </Grid>

                  </Box>
                </Grid>

                <Box sx={{ width: "100%", display: "flex", marginLeft: "16px" }}  >
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderBottom: 0, borderColor: 'grey.300', borderBottomLeftRadius: 0, borderBottomRightRadius: 0, display: "flex", bgcolor: "#F1F8E9", borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
                  >
                    <Grid container justifyContent={"center"}>

                      <Grid item xs={1} md={1} justifyContent={"center"} display={"flex"} >
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStyles}>
                          Quantidade
                        </Typography>
                      </Grid>

                      <Grid item xs={1} md={1} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStyles}>
                          Código
                        </Typography>
                      </Grid>

                      <Grid item xs={1.5} md={1.5} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStyles}>
                          Nº Original
                        </Typography>
                      </Grid>

                      <Grid item xs={4} md={4} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStyles}>
                          Descrição
                        </Typography>
                      </Grid>

                      <Grid item xs={2} md={2} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStyles}>
                          Marca
                        </Typography>
                      </Grid>

                      <Grid item xs={1} md={1} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStyles}>
                          Unitário R$
                        </Typography>
                      </Grid>

                      <Grid item xs={1.5} md={1.5} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStyles}>
                          Sub-Total R$
                        </Typography>
                      </Grid>
                    </Grid>

                    {
                      _dadosPedido?.preVendasItens.map((xprod) => {
                        let _demaisDadosProdutos = _dadosPedido.produtosDemaisDadosClass.filter(m => m.codigo == xprod.codigo);
                        let _marcaDescricao = _demaisDadosProdutos[0].produtoMarca;
                        let _pesoProduto = _demaisDadosProdutos[0].produtoPeso;
                        pesoTotal = (Number(pesoTotal) + Number(_pesoProduto) * Number(xprod?.quantidade));
                        quantidadeTotalItens = (Number(quantidadeTotalItens) + Number(xprod?.quantidade));

                        return (
                          <Grid container justifyContent={"center"} sx={{ bgcolor: '#fff' }}>
                            <Grid item xs={1}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px' }} variant="body2" component="div" classeName={itensStyles}>
                                {xprod?.quantidade}
                              </Typography>
                            </Grid>

                            <Grid item xs={1} md={1} justifyContent={"right"} display={"flex"}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '12px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {xprod?.codigo}
                              </Typography>
                            </Grid>

                            <Grid item xs={1.5} md={1.5} justifyContent={"left"} display={"flex"}>
                              <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {xprod?.n_original}
                              </Typography>
                            </Grid>

                            <Grid item xs={4} md={4} justifyContent={"left"} display={"flex"}>
                              <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {xprod?.descricao}
                              </Typography>
                            </Grid>

                            <Grid item xs={2} md={2} justifyContent={"left"} display={"flex"}>
                              <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {_marcaDescricao}
                              </Typography>
                            </Grid>

                            <Grid item xs={1} md={1} justifyContent={"right"} display={"flex"}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '12px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {numberWithCommas(xprod?.preco)}
                              </Typography>
                            </Grid>

                            <Grid item xs={1.5} md={1.5} justifyContent={"right"} display={"flex"}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {numberWithCommas(xprod?.preco * xprod?.quantidade)}
                              </Typography>
                            </Grid>
                          </Grid>
                        )

                      })
                    }
                  </Grid>
                </Box>
              </Grid>


              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderColor: 'grey.300', borderTopLeftRadius: 0, borderTopRightRadius: 0, display: "flex", bgcolor: "#F1F8E9" }}
              >
                <Grid item xs={10} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    Sub-Total R$
                  </Typography>
                </Grid>
                <Grid item xs={2} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    {numberWithCommas(_dadosPedido?.preVendas?.total_produtos)}
                  </Typography>
                </Grid>

                {_dadosPedido?.preVendas?.totalDescontos > 0.00
                  ?
                  <>
                    <Grid item xs={10} justifyContent={"right"} display={"flex"}>
                      <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                        Desconto R$
                      </Typography>
                    </Grid>
                    <Grid item xs={2} justifyContent={"right"} display={"flex"}>
                      <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px', color: 'red' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                        {numberWithCommas(_dadosPedido?.preVendas?.total_descontos)}
                      </Typography>
                    </Grid>
                  </>
                  :
                  <></>
                }

                <Grid item xs={2} justifyContent={"left"} display={"flex"}>
                  <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginLeft: '10px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    Peso Total: {numberWithCommas(pesoTotal)} Kg.
                  </Typography>
                </Grid>

                <Grid item xs={8} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    {_dadosPedido?.preVendas?.transporteModelo}
                  </Typography>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    Frete R$
                  </Typography>
                </Grid>
                <Grid item xs={2} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    {numberWithCommas(_dadosPedido?.preVendas?.total_frete)}
                  </Typography>
                </Grid>

                <Grid item xs={4} justifyContent={"left"} display={"flex"}>
                  <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginLeft: '10px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    Nº de Itens: {_dadosPedido?.preVendasItens.length} Totalizando {quantidadeTotalItens} {quantidadeTotalItens > 1 ? 'Produtos' : 'Produto'}
                  </Typography>
                </Grid>
                <Grid item xs={6} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    Total R$
                  </Typography>
                </Grid>
                <Grid item xs={2} justifyContent={"right"} display={"flex"} borderTop={1} borderColor={'grey.600'}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", fontSize: "15px", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    {numberWithCommas(_dadosPedido?.preVendas?.total_geral)}
                  </Typography>
                </Grid>

              </Grid>


              <Box sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderColor: 'grey.300', display: "flex" }}  >

                {_dadosPedido?.especie == null
                  ?
                  <>
                    <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="h7" component="div" gutterBottom>
                      Opções de Pagamento:
                    </Typography>
                    <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '6px', marginRight: '6px' }} variant="h7" component="div" gutterBottom>
                      AGUARDANDO PAGAMENTO
                    </Typography>
                  </>
                  :
                  <Grid container justifyContent={"left"}>
                    <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="h7" component="div" gutterBottom>
                      Opções de Pagamento:
                    </Typography>

                    <Grid
                      container
                      direction="row"
                      justifyContent="left"
                      alignItems="left"
                      sx={{ width: "100%", border: 0, borderRadius: 2, marginLeft: '-1px', display: "flex", bgcolor: "#fff" }}
                    >
                      {
                        _dadosPedido?.especie.map((xpag) => {
                          return (
                            <>
                              <Grid item xs={1.5} justifyContent={"left"} display={"flex"} style={{ borderLeft: "1px solid #e2e2e2" }}>
                                <></>
                              </Grid>
                              <Grid item xs={6} justifyContent={"left"} display={"flex"} fontWeight={'bold'} fontSize={'14px'}>
                                {xpag.tipo} {(xpag.nband == 17 ? (xpag.pix_recebido == null ? "" : " - RECEBIDO EM ") : "") + formatarDataHora(xpag.pix_recebido, 6) } { xpag.bandeira } {(xpag.cartao != null ? xpag.cartao : "")} { ( xpag.cartao != null && xpag?.cartao.length > 0 && xpag?.nband != 5 ? ' em ' + xpag?.vezes + (xpag?.vezes > 1 ? ' Vezes' : ' Vez') : '' ) }
                              </Grid>
                              <Grid item xs={2} justifyContent={"right"} display={"flex"} fontWeight={'bold'} fontSize={'14px'}>
                                {'R$ ' + numberWithCommas(xpag?.valor)}
                              </Grid>
                              <Grid item xs={1.5} justifyContent={"left"} display={"flex"}>
                                &nbsp;
                              </Grid>
                            </>
                          )
                        })
                      }
                    </Grid>

                    {

                      (

                        (_dadosPedido?.linhaDigitavel !== null && _dadosPedido?.linhaDigitavel != "" // 15
                          ?
                          <>
                            <Grid
                              container
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              sx={{ marginBottom: '100px' }}
                            >
                              <Grid item xs={1}>
                                <Box>
                                  <Typography sx={{ fontSize: '13px' }}>Linha Digitável</Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={1}>

                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="left"
                                  alignItems="left">
                                  <Grid item xs={11.5}>
                                    <Typography id="Linha_Digitavel">{formatarLinhaDigitavel(linhaDigitavel)}</Typography>                                    
                                  </Grid>
                                  <Grid item xs={0.5}>
                                      <IconButton onClick={() => { functionCopyToClipboardLinhaDigitavel(); }} style={{ color: "green", height: '14px', width: '14px', marginLeft:'6px' }}><ContentCopyIcon /></IconButton>                                    
                                  </Grid>
                                </Grid>

                              </Grid>

                              <Grid item xs={1}>
                                <Box>
                                  <Button variant="contained" onClick={() => setFazerDownload(true)} download sx={{ background: 'green' }}>
                                    VISUALIZAR BOLETO
                                  </Button>
                                </Box>
                              </Grid>
                            </Grid>
                          </>

                          :

                          (_dadosPedido?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).length > 0 // 17
                            ?
                            <>
                              <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                sx={{ marginBottom: '100px' }}
                              >
                                <Grid item xs={1}>
                                  <Box>
                                    <div ref={qrCodeRef} />
                                  </Box>
                                </Grid>

                                <Grid item xs={1}>
                                  <Box>
                                    <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px' }} onClick={(e) => functionCopyToClipboard(e)}>Copia e Cola</Button>
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                            :
                            <></>)

                        ))

                    }
                  </Grid>
                }
              </Box>

            </Container >
            <ToastContainer />
          </div>
        </BrowserView>


        <MobileView>
          <Grid container justifyContent={"center"} spacing={2}>
            <Grid item xs={6} md={6}>
              <Box display="flex"
                justifyContent="right"
                variant={'rounded'}
                alignItems="center"><Button bgcolor={'color'} onClick={() => setShowModalMeuPedido(false)} startIcon={<Avatar src={CloseIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
            </Grid>
            <Grid item xs={6} md={6}>
              <Box display="flex"
                justifyContent="left"
                variant={'rounded'}
                alignItems="center"><Button bgcolor={'color'} onClick={handlePrint} startIcon={<Avatar src={ImpressaoIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
            </Grid>
          </Grid>

          <div className="div to print" ref={dataToPrintRef}>
            <Container maxWidth="lg" marginBottom={'100px'}>
              <Grid container justifyContent={"center"} spacing={2}>

                <Grid item xs={12} md={12} classeName={gridStyles}>
                  <Box sx={{ width: "100%", marginTop: '10px', borderRadius: 2, border: 1, borderColor: 'grey.300', bgcolor: "#F1F8E9" }}>

                    <Grid container justifyContent={"center"} spacing={2}>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Box sx={{ marginTop: '5px', marginBottom: '5px', marginLeft: '10px' }}>
                          <Link to="/"><img src={LogoNafil} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '180px', height: 'auto' }} /></Link>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Pedido:
                        </Typography>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h6" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.ids_prevendas + "-" + _dadosPedido?.preVendas?.ids_prevendas_loja}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Data:
                        </Typography>
                        <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px' }} variant="h7" component="div" gutterBottom>
                          {formatarDataHora(_dadosPedido?.preVendas?.data, 6)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderColor: 'grey.300', display: "flex" }}  >

                    <Grid container justifyContent={"center"} spacing={0.7}>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="h7" component="div" gutterBottom>
                          Destinatário:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.cliente_razao_social}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Endereço:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.endereco + ", " + _dadosPedido?.preVendas?.numero + (_dadosPedido?.preVendas?.complemento.lenght > 0 ? " - " + _dadosPedido?.preVendas?.complemento : "")}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Bairro:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.bairro}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          CEP:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.preVendas?.cep.substring(0, 5) + "-" + _dadosPedido?.preVendas?.cep.slice(-3)}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Cidade - UF:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h7" component="div" gutterBottom>
                          {_dadosPedido?.cidadeDestino + " - " + _dadosPedido?.ufDestino}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          Telefone:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h7" component="div" gutterBottom>
                          {formatarTelefone(_dadosPedido?.preVendas?.cliente_telefone)}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                          E-Mail:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '-6px' }} variant="h7" component="div" gutterBottom>
                          {(typeof _dadosPedido !== "undefined" && _dadosPedido?.preVendas?.cliente_email != null ? _dadosPedido?.preVendas?.cliente_email.toLowerCase() : "")}
                        </Typography>
                      </Grid>

                      {(_dadosPedido?.preVendas?.referencia.length > 0
                        ?
                        <>
                          <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                            <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px' }} variant="h7" component="div" gutterBottom>
                              Referência:
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12} justifyContent={"left"} display={"flex"}>
                            <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px' }} variant="h7" component="div" gutterBottom>
                              {_dadosPedido?.preVendas?.referencia}
                            </Typography>
                          </Grid>
                        </>
                        :
                        <></>
                      )}

                    </Grid>

                  </Box>
                </Grid>

                <Box sx={{ width: "100%", display: "flex", marginLeft: "16px" }}  >
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderBottom: 0, borderColor: 'grey.300', borderBottomLeftRadius: 0, borderBottomRightRadius: 0, display: "flex", bgcolor: "#F1F8E9", borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
                  >
                    <Grid container justifyContent={"center"}>

                      <Grid item xs={2} justifyContent={"center"} display={"flex"} >
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStylesMobile}>
                          Quant.
                        </Typography>
                      </Grid>

                      <Grid item xs={2} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStylesMobile}>
                          Código
                        </Typography>
                      </Grid>

                      <Grid item xs={3.5} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStylesMobile}>
                          Nº Orig.
                        </Typography>
                      </Grid>                      

                      <Grid item xs={4.5} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStylesMobile}>
                          Marca
                        </Typography>
                      </Grid>

                      <Grid item xs={7} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStylesMobile}>
                          Descrição
                        </Typography>                        
                      </Grid>

                      <Grid item xs={2} justifyContent={"center"} display={"flex"}>
                        <Typography sx={{ textAlign: "center", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStylesMobile}>
                          Unit. R$
                        </Typography>
                      </Grid>

                      <Grid item xs={3} justifyContent={"left"} display={"flex"}>
                        <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={cabecalhoStylesMobile}>
                          Sub-Total R$
                        </Typography>
                      </Grid>
                    </Grid>

                    {
                      _dadosPedido?.preVendasItens.map((xprod) => {
                        let _demaisDadosProdutos = _dadosPedido.produtosDemaisDadosClass.filter(m => m.codigo == xprod.codigo);
                        let _marcaDescricao = _demaisDadosProdutos[0].produtoMarca;
                        let _pesoProduto = _demaisDadosProdutos[0].produtoPeso;
                        pesoTotal = (Number(pesoTotal) + Number(_pesoProduto) * Number(xprod?.quantidade));
                        quantidadeTotalItens = (Number(quantidadeTotalItens) + Number(xprod?.quantidade));

                        return (
                          <Grid container justifyContent={"center"} sx={{ bgcolor: '#fff' }}>
                            <Grid item xs={2}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px' }} variant="body2" component="div" classeName={itensStyles}>
                                {xprod?.quantidade}
                              </Typography>
                            </Grid>

                            <Grid item xs={2} justifyContent={"right"} display={"flex"}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '12px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {xprod?.codigo}
                              </Typography>
                            </Grid>

                            <Grid item xs={3.5} justifyContent={"left"} display={"flex"}>
                              <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {xprod?.n_original}
                              </Typography>
                            </Grid>

                            <Grid item xs={4.5} justifyContent={"left"} display={"flex"}>
                              <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {_marcaDescricao}
                              </Typography>
                            </Grid>


                            <Grid item xs={7} justifyContent={"left"} display={"flex"}>
                              <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '10px', marginTop: '6px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {xprod?.descricao}
                              </Typography>
                            </Grid>


                            <Grid item xs={2} justifyContent={"right"} display={"flex"}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {numberWithCommas(xprod?.preco)}
                              </Typography>
                            </Grid>

                            <Grid item xs={3} justifyContent={"right"} display={"flex"}>
                              <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                                {numberWithCommas(xprod?.preco * xprod?.quantidade)}
                              </Typography>
                            </Grid>
                          </Grid>
                        )

                      })
                    }
                  </Grid>
                </Box>
              </Grid>


              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderColor: 'grey.300', borderTopLeftRadius: 0, borderTopRightRadius: 0, display: "flex", bgcolor: "#F1F8E9" }}
              >
                <Grid item xs={10} md={10} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    Sub-Total R$
                  </Typography>
                </Grid>
                <Grid item xs={2} md={2} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                    {numberWithCommas(_dadosPedido?.preVendas?.total_produtos)}
                  </Typography>
                </Grid>

                {_dadosPedido?.preVendas?.totalDescontos > 0.00
                  ?
                  <>
                    <Grid item xs={10} md={10} justifyContent={"right"} display={"flex"}>
                      <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                        Desconto R$
                      </Typography>
                    </Grid>
                    <Grid item xs={2} md={2} justifyContent={"right"} display={"flex"}>
                      <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px', color: 'red' }} variant="body2" component="div" gutterBottom classeName={itensStyles}>
                        {numberWithCommas(_dadosPedido?.preVendas?.total_descontos)}
                      </Typography>
                    </Grid>
                  </>
                  :
                  <></>
                }

                <Grid item xs={2} md={2} justifyContent={"left"} display={"flex"}>
                  <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginLeft: '10px' }} variant="body2" component="div" gutterBottom classeName={itensStylesRodapeMobile}>
                    Peso Total: {numberWithCommas(pesoTotal)} Kg.
                  </Typography>
                </Grid>

                <Grid item xs={8} md={8} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStylesRodapeMobile}>
                    {_dadosPedido?.preVendas?.transporteModelo}
                  </Typography>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStylesRodapeMobile}>
                    Frete R$
                  </Typography>
                </Grid>
                <Grid item xs={2} md={2} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStylesRodapeMobile}>
                    {numberWithCommas(_dadosPedido?.preVendas?.total_frete)}
                  </Typography>
                </Grid>

                <Grid item xs={4} md={4} justifyContent={"left"} display={"flex"}>
                  <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginLeft: '10px' }} variant="body2" component="div" gutterBottom classeName={itensStylesRodapeMobile}>
                    Nº de Itens: {_dadosPedido?.preVendasItens.length} Totalizando {quantidadeTotalItens} {quantidadeTotalItens > 1 ? 'Produtos' : 'Produto'}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={6} justifyContent={"right"} display={"flex"}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStylesRodapeMobile}>
                    Total R$
                  </Typography>
                </Grid>
                <Grid item xs={2} md={2} justifyContent={"right"} display={"flex"} borderTop={1} borderColor={'grey.600'}>
                  <Typography sx={{ textAlign: "right", fontFamily: "roboto", fontWeight: "bold", fontSize: "15px", marginTop: '6px', marginRight: '22px' }} variant="body2" component="div" gutterBottom classeName={itensStylesRodapeMobile}>
                    {numberWithCommas(_dadosPedido?.preVendas?.total_geral)}
                  </Typography>
                </Grid>

              </Grid>


              <Box sx={{ width: "100%", borderRadius: 2, border: 1, borderTop: 0, borderColor: 'grey.300', display: "flex" }}  >

                {_dadosPedido?.especie == null
                  ?
                  <>
                    <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="h8" component="div" gutterBottom>
                      Opções de Pagamento:
                    </Typography>
                    <Typography sx={{ textAlign: "left", fontFamily: "roboto", fontWeight: "bold", marginLeft: '6px', marginTop: '6px', marginRight: '6px' }} variant="h8" component="div" gutterBottom>
                      AGUARDANDO PAGAMENTO
                    </Typography>
                  </>
                  :
                  <Grid container justifyContent={"left"}>
                    <Typography sx={{ textAlign: "left", fontFamily: "roboto", marginLeft: '10px', marginTop: '6px' }} variant="h8" component="div" gutterBottom>
                      Opções de Pagamento:
                    </Typography>

                    <Grid
                      container
                      direction="row"
                      justifyContent="left"
                      alignItems="left"
                      sx={{ width: "100%", border: 0, borderRadius: 2, marginLeft: '-1px', display: "flex", bgcolor: "#fff" }}
                    >
                      {
                        _dadosPedido.especie.map((xpag) => {
                          return (
                            <>
                              <Grid item xs={1.5} justifyContent={"left"} display={"flex"} style={{ borderLeft: "1px solid #e2e2e2" }}>
                                <></>
                              </Grid>
                              <Grid item xs={6} justifyContent={"left"} display={"flex"} fontWeight={'bold'} fontSize={'14px'}>
                                {xpag.tipo} {xpag.bandeira} {(xpag.cartao != null ? xpag.cartao : "")} {(xpag.cartao != null && xpag.cartao.length > 0 && xpag.nband != 5 ? ' em ' + xpag.vezes + (xpag.vezes > 1 ? ' Vezes' : ' Vez') : '' )}
                              </Grid>
                              <Grid item xs={2} justifyContent={"right"} display={"flex"} fontWeight={'bold'} fontSize={'14px'}>
                                {'R$ ' + numberWithCommas(xpag.valor)}
                              </Grid>
                              <Grid item xs={1.5} justifyContent={"left"} display={"flex"}>
                                &nbsp;
                              </Grid>
                            </>
                          )
                        })
                      }
                    </Grid>

                    {

                      (

                        (_dadosPedido?.especie.filter((xp) => xp.nband == 15).length > 0 // 15 - BOLETO BANCÁRIO
                          ?
                          <>
                            <Grid
                              container
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              sx={{ marginBottom: '100px' }}
                            >
                              <Grid item xs={1}>
                                <Box>
                                  <Typography sx={{ fontSize: '8px' }}>Linha Digitável</Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={1}>

                              <Grid
                                  container
                                  direction="row"
                                  justifyContent="left"
                                  alignItems="left">
                                  <Grid item xs={11.5}>
                                    <Typography id="Linha_Digitavel" sx={{ fontSize:'8px' }}>{formatarLinhaDigitavel(linhaDigitavel)}</Typography>                                    
                                  </Grid>
                                  <Grid item xs={0.5}>
                                      <IconButton onClick={() => { functionCopyToClipboardLinhaDigitavel(); }} style={{ color: "green", height: '14px', width: '14px', marginLeft:'6px' }}><ContentCopyIcon /></IconButton>                                    
                                  </Grid>
                                </Grid>

                              </Grid>

                              <Grid item xs={1}>
                                <Box>                                  
                                  <Button variant="contained" onClick={() => setFazerDownload(true)} download sx={{ background: 'green' }}>
                                    VISUALIZAR BOLETO
                                  </Button>
                                </Box>
                              </Grid>
                            </Grid>
                          </>

                          :


                          _dadosPedido.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).length > 0 // 17 - PIX
                            ?
                            <>
                              <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                sx={{ marginBottom: '100px' }}
                              >
                                <Grid item xs={1}>
                                  <Box>
                                    <div ref={qrCodeRef} />
                                  </Box>
                                </Grid>

                                <Grid item xs={1}>
                                  <Box>
                                    <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px' }} onClick={(e) => functionCopyToClipboard(e)}>Copia e Cola</Button>
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                            :
                            <></>
                        ))
                    }

                  </Grid>
                }
              </Box>

            </Container >
            <ToastContainer />
          </div>
        </MobileView>

      </div>

  )
}